/* eslint-disable no-param-reassign */
import { createStore } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import type { AiAssistPromptsEditorStateData } from '../../types/entities';

export type AiAssistPromptsEditorStateStore = AiAssistPromptsEditorState &
  AiAssistPromptsEditorStateActions;

export interface AiAssistPromptsEditorState {
  aiAssistPromptsData: AiAssistPromptsEditorStateData;
}

export interface AiAssistPromptsEditorStateActions {
  setAiAssistPromptsData: (data: AiAssistPromptsEditorStateData) => void;
  resetAiAssistPromptsData: () => void;
  getAiAssistPrompt: (fieldPath: string) => string | undefined;
  setAiAssistPrompt: (fieldPath: string, prompt: string) => void;
  removeAiAssistPrompt: (fieldPath: string) => void;
}

export const aiAssistPromptsEditorStateStore =
  createStore<AiAssistPromptsEditorStateStore>()(
    immer((set, get) => ({
      aiAssistPromptsData: {
        fields: {},
      },
      setAiAssistPromptsData: (data) =>
        set((draft) => {
          draft.aiAssistPromptsData = data;
        }),
      resetAiAssistPromptsData: () =>
        set((draft) => {
          draft.aiAssistPromptsData = { fields: {} };
        }),
      getAiAssistPrompt: (fieldPath) =>
        get().aiAssistPromptsData.fields[fieldPath],
      setAiAssistPrompt: (fieldPath, prompt) =>
        set((draft) => {
          draft.aiAssistPromptsData.fields[fieldPath] = prompt;
        }),
      removeAiAssistPrompt: (fieldPath) =>
        set((draft) => {
          delete draft.aiAssistPromptsData.fields[fieldPath];
        }),
    })),
  );
